Flup.service('input-validation', function (flup) {
	var that = this
	that.addError = function ($form, inputName, msg) {
		var $errorElm = $(`<small id='flup-validation-${inputName}-errror' class='text-danger'>${msg}</small>`)
		var $input = $form.find("[name='" + inputName + "']")
		var $formGroup = $input.closest('.form-group').addClass('has-error')
		var $validatorHolder = $form.find("[data-validator='" + inputName + "']")
		if ($validatorHolder.length) {
			return $validatorHolder.append($errorElm)
		} else if ($formGroup.length) {
			$formGroup.append($errorElm)
			return $input
		}
		return null
	}

	that.clear = function ($form) {
		$form.find('[name]').each(function () {
			$(this).closest('.form-group').removeClass('has-error').find('small.text-danger').remove()
		})
		$form.find('[data-validator]').empty()
	}

	that.validateAll = function ($form, opt) {
		that.clear($form)
		var $elms = []
		var validated = true

		for (var x in opt) {
			var $input = $form.find("[name='" + x + "']")
			var funcs = opt[x]
			for (var i = 0; i < funcs.length; i++) {
				var res = funcs[i]($input)
				if (res !== true) {
					validated = false
					var $elm = that.addError($form, x, res)
					if ($elm) $elms.push($elm)
					break
				}
			}
		}

		if ($elms.length) {
			flup('focus').focusTopElm($elms, true)
		}

		return validated
	}
})
